var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group col-md-4"},_vm._l((_vm.videos),function(video){return _c('VideoListItem',{key:video.etag,attrs:{"video":video},on:{"videoSelect":_vm.onVideoSelect}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }